import { Compensation, CreateCompensationResponse } from '@/services/compensation';
import { Td, Th, Tr } from '@/trio-ui/Table';
import * as Styles from './StaffMemberCompensationSection.styles';
import SectionBox from '../SectionBox';
import StaffMemberCompensationRow from '../StaffMemberCompensationRow';

export type NewCompensationFlag = 'NEW_COMPENSATION';

export type Props = {
  id?: string;
  isEditingMap?: Record<string, boolean>;
  onEditClick?: (id: string) => void;
  onEditComplete?: (id: string) => void;
  onAddClick?: () => void;
  isAdding?: boolean;
  staffMemberId: string;
  compensations?: Compensation[];
  refreshCompensations?: () => void;
  setIsAdding?: (value: boolean) => void;
};

const StaffMemberCompensationSection = ({
  id,
  compensations = [],
  isEditingMap = {},
  onEditClick,
  onEditComplete,
  onAddClick,
  staffMemberId,
  isAdding = false,
  refreshCompensations,
  setIsAdding,
}: Props): JSX.Element => {
  const tableData: Array<Compensation | NewCompensationFlag> = [...compensations];

  if (isAdding) {
    tableData.push('NEW_COMPENSATION');
  }

  const handleAddCompensation = (): void => {
    setIsAdding?.(false);
    refreshCompensations?.();
  };

  const handleEditCompensation = (compensation: CreateCompensationResponse): void => {
    onEditComplete?.(compensation.id);
    refreshCompensations?.();
  };

  return (
    <SectionBox title="Compensation" id={id} className="tw-relative">
      <Styles.TableContainer className="tw-mb-4">
        <Styles.Table
          customBorderRadius={8}
          data={tableData}
          renderHeader={
            <Tr>
              <Th>Start Date</Th>
              <Th>End Date</Th>
              <Th>Hourly Rate</Th>
              <Th>Monthly payment</Th>
              <Th>Change Reason</Th>
              <Th />
            </Tr>
          }
          renderEmptyState={
            <Tr>
              <Td
                colSpan={5}
                textAlign="center"
                padding="28px 74px"
                fontSize={14}
                lineHeight="150%"
              >
                No compensations.
              </Td>
            </Tr>
          }
          renderRow={(data) => {
            const key = data === 'NEW_COMPENSATION' ? data : data.id;

            return (
              <StaffMemberCompensationRow
                staffMemberId={staffMemberId}
                key={key}
                compensation={data === 'NEW_COMPENSATION' ? undefined : data}
                isEditing={data === 'NEW_COMPENSATION' || isEditingMap[data.id]}
                onAddNewCompensation={handleAddCompensation}
                onEditCompensation={handleEditCompensation}
                onEditClick={() => {
                  if (data !== 'NEW_COMPENSATION') {
                    onEditClick?.(data.id);
                  }
                }}
              />
            );
          }}
        />
      </Styles.TableContainer>
      <button
        type="button"
        className="tw-self-start tw-text-primary-60 tw-text-sm"
        onClick={onAddClick}
      >
        + Add Compensation
      </button>
    </SectionBox>
  );
};

export default StaffMemberCompensationSection;
